"use strict";

var _classCallCheck = require("/drone/src/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/drone/src/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AuthEvents = /*#__PURE__*/function () {
  function AuthEvents() {
    _classCallCheck(this, AuthEvents);
  }

  _createClass(AuthEvents, null, [{
    key: "addListenRenew",
    value: function addListenRenew(fn) {
      window.addEventListener(AuthEvents.EVENTS.RENEW, fn);
    }
  }, {
    key: "removeListenRenew",
    value: function removeListenRenew(fn) {
      window.removeEventListener(AuthEvents.EVENTS.RENEW, fn);
    }
  }, {
    key: "addListenRenewError",
    value: function addListenRenewError(fn) {
      window.addEventListener(AuthEvents.EVENTS.RENEW_ERROR, fn);
    }
  }, {
    key: "removeListenRenewError",
    value: function removeListenRenewError(fn) {
      window.removeEventListener(AuthEvents.EVENTS.RENEW_ERROR, fn);
    }
  }, {
    key: "addListenUser",
    value: function addListenUser(fn) {
      window.addEventListener(AuthEvents.EVENTS.USER, fn);
    }
  }, {
    key: "removeListenUser",
    value: function removeListenUser(fn) {
      window.removeEventListener(AuthEvents.EVENTS.USER, fn);
    }
  }, {
    key: "dispatchUser",
    value: function dispatchUser(user) {
      window.dispatchEvent(new CustomEvent(AuthEvents.EVENTS.USER, {
        detail: user
      }));
    }
  }, {
    key: "dispatchRenew",
    value: function dispatchRenew() {
      window.dispatchEvent(new CustomEvent(AuthEvents.EVENTS.RENEW));
    }
  }, {
    key: "dispatchRenewError",
    value: function dispatchRenewError() {
      window.dispatchEvent(new CustomEvent(AuthEvents.EVENTS.RENEW_ERROR));
    }
  }]);

  return AuthEvents;
}();

exports.default = AuthEvents;
AuthEvents.EVENTS = {
  RENEW: 'cas-js:renew',
  RENEW_ERROR: 'cas-js:renew-error',
  USER: 'cas-js:user'
};